import { useState } from 'react';
import { ControlledAccordionCollapse } from './ControlledAccordionCollapse';

export const AccordionCollapse = ({
    defaultOpen,
    ...restProps
}) => {
    const [open, setOpen] = useState(defaultOpen);

    return (
        <ControlledAccordionCollapse
            open={open}
            setOpen={setOpen}
            {...restProps}
        />
    );
};